// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"9775b545","358":"463a7469","484":"6111f80d","551":"994a0952","629":"e983e186","828":"05735cb2","869":"36db1b84","974":"6c685008"}[chunkId] + ".chunk.js";
};